<template>
  <div class="container">
    <nav-box title="先付模式" :back="false">
      <template #action>
        <div class="setting-btn" @click="openSettings">设置</div>
      </template>
    </nav-box>
    <div class="content flex-column">
      <div class="tab flex" v-if="settingsData.showCard!=false">
        <div
          class="tab-item flex flex-center"
          :class="active == 1 ? 'on' : ''"
          @click="changeTab(1)"
        >
          单人购票
        </div>
        <div
          class="tab-item flex flex-center"
          :class="active == 2 ? 'on' : ''"
          @click="changeTab(2)"
        >
          多人购票
        </div>
      </div>
      <div v-show="active == 1" class="flex">
        <div class="code-box flex-column flex-center">
          <div class="code">
            <img :src="imageUrl" alt="" />
          </div>
          <p class="tip">请使用“ 微信 ”扫描上方二维码</p>
        </div>
      </div>
      <div v-show="active == 2" class="flex flex-column guest-list" style="width: 100%">
        <div class="guest-box flex-column" v-for="(coupon,index) in couponList" :key="coupon.key">
          
          <div class="top flex flex-sb" v-if="coupon.code">
            <div class="seq-number">券{{ index+1 }}</div>
            <div class="close" @click="deleteCoupon(index)">关闭</div>
          </div>
          <div class="title flex flex-column" v-if="coupon.code">
            <p class="name">{{ coupon.name }}<span>{{ coupon.availablePersons }}人券</span></p>
            <p class="date">有效期至{{ coupon.failureDate}}</p>
          </div>
          <div class="guest-sex flex flex-sb">
            <div class="sex-item flex flex-column">
              <div class="sex flex flex-center">
                <img src="@/assets/man.png" alt="" sizes="" srcset="" />
                <span>男宾</span>
              </div>
              <div class="num flex flex-center">
                <div class="minus flex" @click="minusNum(coupon,'manNumber')">
                  <img
                    src="@/assets/minus-icon.png"
                    v-if="coupon.manNumber > 0"
                    alt=""
                  />
                  <img src="@/assets/minus-icon-disable.png" v-else alt="" />
                </div>
                <div class="number">
                  {{ coupon.manNumber }}
                </div>
                <div class="add flex" @click="addNum(coupon,'manNumber')">
                  <img src="@/assets/add-icon.png" alt="" />
                </div>
              </div>
            </div>
            <div class="sex-item flex flex-column">
              <div class="sex flex flex-center">
                <img src="@/assets/woman.png" alt="" sizes="" srcset="" />
                <span>女宾</span>
              </div>
              <div class="num flex flex-center">
                <div class="minus flex" @click="minusNum(coupon,'womanNumber')">
                  <img
                    src="@/assets/minus-icon.png"
                    v-if="coupon.womanNumber > 0"
                    alt=""
                  />
                  <img src="@/assets/minus-icon-disable.png" v-else alt="" />
                </div>
                <div class="number">
                  {{ coupon.womanNumber }}
                </div>
                <div class="add flex" @click="addNum(coupon,'womanNumber')">
                  <img src="@/assets/add-icon.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-bottom">

          <div class="flex flex-baseline flex-sb">
            <p class="title" v-if="guestTypeList.length>1 && settingsData.showGuestType!=false">客人类型：</p>
            <div class="guest-type-selector" @click="openGuestTypePopup" v-if="guestTypeList.length>1 && settingsData.showGuestType!=false">
              <span>{{ selectedGuestTypeName || '请选择' }}</span>
              <img src="@/assets/bottom.png" class="arrow-icon" alt="" />
            </div>
          </div>

          <div class="btn-group flex flex-sb">
            <div class="btn-item reset flex flex-center" @click="reset">
              <span v-if="!resetCountdownTimer">重置</span>
              <span v-else>重置（{{ resetCountdownSeconds }}）</span>
            </div>
            <div class="btn-item affirm flex flex-center" @click="affirm">
              确认
            </div>
          </div>
        </div>


      </div>
    </div>

    <login-box v-if="showLogin" @login="login" @cancel="cancelBox"></login-box>

    <!-- 优惠券核销 -->
    <div class="pay-popup flex-column" v-if="isShowUseCoupon"  @click="setCouponCodeFocus">
      <div class="pay-window flex-column flex-center">
        <div class="pay-tip flex-column flex-center">
          <p>请将兑换券二维码置于</p>
          <p>自助机下方识别区</p>
          <div class="pay-img">
            <img class="scan-img" src="@/assets/scan.png" alt="" />
          </div>
          
          <div class="cancel-account flex flex-center" @click="closeUseCoupon" ref="refClose">
            {{ countdownTimer?'完成扫码':'关闭扫码' }}
          </div>
          <div v-if="countdownTimer">
            <div class="explanation">
              <p>多张兑换券扫码完成后，点击完成扫码</p>
              <p>进入选择人数核销</p>
            </div>
            <div class="countdown">倒计时 {{ countdownSeconds }} 秒</div>
          </div>
        </div>
        <div class="scan-box">
          <input type="text" ref="couponCodeRef" class="box" v-model="couponCode" @keyup.enter="enterUseCoupon"/>
        </div>
      </div>
    </div>

    <!-- 选择门店 -->
    <div class="pay-popup flex-column" v-if="isShowShop">
      <div class="pay-window flex-column flex-center">
        <div class="pay-tip flex-column flex-center">
          <p class="title">选择门店</p>
          <p>
            <select v-model="appShopId">
              <option value="">请选择门店</option>
              <option v-for="shop in appShopList" :key="shop.appShopId" :value="shop.appShopId">{{ shop.appShopName }}</option>
            </select>
          </p>
          <div class="flex flex-center" @click="confirmShop">
            确定
          </div>
        </div>
      </div>
    </div>

    <!-- 核销中弹窗 -->
    <div class="pay-popup flex-column" v-if="showAffirmLoading">
      <div class="pay-window flex-column flex-center">
        <div class="pay-tip flex-column flex-center">
          <p class="loading-text">正在核销中...</p>
          <p class="loading-subtext">请稍候</p>
        </div>
      </div>
    </div>

    <!-- 客人类型选择弹窗 -->
    <div class="bottom-popup" v-if="showGuestTypePopup" @click="closeGuestTypePopup">
      <div class="bottom-popup-content" @click.stop>
        <div class="popup-header">
          <p class="popup-title">选择客人类型</p>
          <div class="close-btn" @click="closeGuestTypePopup">✕</div>
        </div>
        <div class="popup-body">
          <div
            class="guest-type-item"
            v-for="item in guestTypeList"
            :key="item.id"
            :class="{ active: guestTypeId === item.id }"
            @click="selectGuestType(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import navBox from "@/components/nav-box.vue";
import LoginBox from "@/components/login-box.vue";
import axios from "axios";
import moment from "moment";

export default {
  components: {
    navBox,
    LoginBox
  },
  name: "prepayment",
  data() {
    return {
      active: 2,
      imageUrl: "",
      guestTypeList: [],
      guestTypes:[],
      guestTypeId: "",
      timer: null,
      settingsData:{},
      loading:false,

      showLogin: false, // 显示登录弹窗
      loginToken: "",

      isShowUseCoupon:false,//显示优惠券弹窗
      couponCode:null,//券码
      couponList:[],
      countdownSeconds: 60,//倒计时秒数
      countdownTimer: null,//倒计时定时器
      resetCountdownSeconds: 60,//重置倒计时秒数
      resetCountdownTimer: null,//重置倒计时定时器
      isAffirming: false, // 是否正在核销中
      showAffirmLoading: false, // 显示核销中弹窗
      showGuestTypePopup: false, // 显示客人类型选择弹窗

      thirdType:256,
      appShopId:'',
      appShopList:[],
      isShowShop:false,
    };
  },
  async created() {
    if (this.active == 1) {
      this.getCode();
      this.setTime();
    }

    await this.getGuestType();
    this.getUserPreference()
  },
  computed: {
    selectedGuestTypeName() {
      const guestType = this.guestTypeList.find(item => item.id === this.guestTypeId);
      return guestType ? guestType.name : '';
    }
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    this.timer = null;
    // 清除倒计时定时器
    if(this.countdownTimer){
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    // 清除重置倒计时定时器
    if(this.resetCountdownTimer){
      clearInterval(this.resetCountdownTimer);
      this.resetCountdownTimer = null;
    }
  },
  methods: {
    setCouponCodeFocus(){
      this.$nextTick(()=>{
        this.$refs.couponCodeRef.focus()
      })
    },
    closeUseCoupon(){
      this.isShowUseCoupon = false
      this.couponCode = null //券码
      this.loading = false;
      // 清除倒计时定时器
      if(this.countdownTimer){
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      // 启动重置倒计时
      this.startResetCountdown();
    },
    confirmShop(){
      if(!this.appShopId){
        this.$toast("请选择门店");
        return;
      }
      this.isShowShop = false
      this.getConsumptionPackageCoupons(this.thirdType,this.appShopId)
    },
    enterUseCoupon(){
      if(this.loading){
        return;
      }
      this.loading = true;

      console.log(this.couponCode)
      if(!this.couponCode){
        this.loading = false;
        return;
      }

      // 1：美团，2：口碑，4：抖音，8：会员券，16：微信商城，32：景区，64：快手，128：包价项目
      this.thirdType = 256
      this.appShopList = []
      this.appShopId = ''

      if(/^000\d{9}$/.test(this.couponCode)){
        this.thirdType = 8
      }else if(this.couponCode.includes("wx-")){
        // 微信商城优惠券
        this.thirdType = 16;
        this.couponCode = this.couponCode.replace(/wx-/, "")
      }else if(this.checkScenicArea(this.couponCode)){
        this.thirdType = 32;
      }else if(this.couponCode.includes("douyin") || this.couponCode.length==15){
        this.thirdType = 4
        this.appShopList = this.tikTokList
      }else if(this.couponCode.length>=11 && this.couponCode.length<=13){
        this.thirdType = 1
        this.appShopList = this.meituanList
      }
      
      if(this.thirdType == 256){
        this.couponCode = ''
        this.$refs.couponCodeRef.value = ''
        this.loading = false;
        this.$toast("核销码识别失败");
        return;
      }

      if(this.thirdType == 1 || this.thirdType == 4){
        if(this.appShopList.length==1){
          this.appShopId = this.appShopList[0].appShopId
          this.getConsumptionPackageCoupons()
        }else if(this.appShopList.length>1){
          this.isShowShop = true
        } else {
          this.loading = false;
          this.$toast("券不可使用，请联系工作人员");
          return;
        }
      }else{
        this.getConsumptionPackageCoupons()
      }
    },
    // 判断是否为景区
    checkScenicArea(couponCode){
      let isHas = false;
      const stores = JSON.parse(localStorage.getItem("stores"));
      stores.forEach(item=>{
        if(couponCode.indexOf(item.storeId)>-1){
          isHas = true;
        }
      })
      return isHas
    },
    // 第三方查询券码对应的套餐
    getConsumptionPackageCoupons() {
      this.$toast.loading({
        message: "查询核销码，请稍后....",
        forbidClick: true,
      });

      //判断是否已存在
      const array = this.couponList.filter(item=>item.code==this.couponCode)
      if(array.length>0){
        this.couponCode = ''
        this.$refs.couponCodeRef.value = ''
        this.$toast("核销码已存在，请不要重复添加");
        this.loading = false;
        return;
      }

      let params = {
        couponCode: this.couponCode,
        thirdType: this.thirdType,
        consumptionAreaId: localStorage.getItem("consumptionAreaId"),
        appShopId:this.appShopId,
      };

      this.couponCode = ''
      this.$refs.couponCodeRef.value = ''

      let url = this.Api.ticket
      if(this.thirdType==16){
        url = this.Api.wechatMallCoupons
      }

      this.$fetchNo(url, params).then(res => {
        this.$toast.clear();

        if (res.code == 1 && res.data) {
          console.log(res.data)

          // 商城返回的多条
          let couponDataList = []
          if(this.thirdType==16){
            couponDataList = res.data
          }else{
            couponDataList = [res.data]
          }

          couponDataList.forEach(async (couponData)=>{
            if(couponData.quantity>0){
              await this.getGuestType();

              // 先匹配套餐
              let guestType = this.guestTypes.find(guestType=>{
                if(guestType.itemPackageIds && guestType.itemPackageIds.length>0){
                  return guestType.itemPackageIds.includes(`${couponData.itemPackage.id}`)
                }
                return false;
              })
  
              // 套餐匹配不到就匹配渠道
              if(!guestType){
                guestType = this.guestTypes.find(guestType=>{
                  if(guestType.thirdType){
                    const thirdType = guestType.thirdType.split(',')
                    return thirdType.includes(`${this.thirdType}`)
                  }
                  return false;
                })
              }
  
              if(!guestType){
                this.loading = false;
                this.$toast("请去客人类型设置，设置核销券类型关联客类");
                return;
              }
  
              for (let index = 0; index < couponData.quantity; index++) {
                const item = {
                  key:`${params.couponCode}-${index}`,
                  encrypted_code:couponData.encrypted_code,
                  orderId:couponData.orderId,
                  pay_amount:couponData.pay_amount,
                  quantity:1,
                  sku_id:couponData.sku_id,
                  verify_token:couponData.verify_token,
                  ...couponData.itemPackage,
                  guestTypeId:guestType.id,
                  thirdType:this.thirdType,
                  appShopId:this.appShopId,
                  code:params.couponCode,
                  availablePersons: 1,
                  failureDate:moment(couponData.failureDate).format('YYYY-MM-DD'),
                  manNumber: 0,
                  womanNumber: 0,
                }

                if(parseInt(couponData.itemPackage.availablePersons)){
                  item.availablePersons = parseInt(couponData.itemPackage.availablePersons)
                }

                if(item.encrypted_code.indexOf(',')>-1){
                  item.encrypted_code = item.encrypted_code.split(',')[index]
                  item.verify_token = item.verify_token+''+index
                }

                this.couponList.push(item);
              }

              console.log('this.couponList=',this.couponList)
              this.loading = false;
              // 扫码成功后启动倒计时
              this.startCountdown();
            }else{
              this.loading = false;
              this.$toast("此券已使用");
            }
          })

        } else {
          this.loading = false;
        }

      }).catch(()=>{
        this.loading = false;
      })
    },

    getTikTokSetting(){
      this.$fetchNo(this.Api.TikTokSetting, {}).then((res) => {
        this.tikTokList = res.data
      })
    },
    getMeituanSetting(){
      this.$fetchNo(this.Api.MeituanSetting, {}).then((res) => {
        this.meituanList = res.data
      })
    },



    login(token) {
      this.loginToken = token;
      this.showLogin = false;
      this.$router.push("/settings");
    },
    cancelBox() {
      this.showLogin = false; // 显示登录弹窗
      this.loginToken = "";
    },
    changeTab(index) {
      this.active = index;
      if (this.active == 1) {
        this.getCode();
        this.setTime();
      } else {
        clearInterval(this.timer); // 清除定时器
        this.timer = null;
      }
      this.reset();
    },
    setTime() {
      //每隔一分钟运行一次保存方法
      this.timer = setInterval(() => {
        this.getCode();
      }, 60000);
    },
    // 重置
    reset() {
      this.showAffirmLoading = false;
      this.isAffirming = false;

      // 清除重置倒计时定时器
      if(this.resetCountdownTimer){
        clearInterval(this.resetCountdownTimer);
        this.resetCountdownTimer = null;
      }
      this.couponList = []
      if(this.settingsData.isUseCoupon && this.active == 2){
        this.openAddCoupon();
      }
    },
    // 确定
    affirm() {
      // 防止重复点击
      if(this.isAffirming){
        return;
      }

      console.log('affirm()')
      if(this.settingsData.isUseCoupon){
        if(this.couponList.length==0){
          this.$toast('请先添加优惠券');
          return;
        }

        for (let index = 0; index < this.couponList.length; index++) {
          const item = this.couponList[index];
          const size = item.manNumber + item.womanNumber
          if(size==0){
            this.$toast('优惠券没有设置人数');
            return;
          }
          if(item.availablePersons!=size){
            this.$toast('该套餐对应登记人数错误，请重新选择登记人数');
            return;
          }
        }

        // 设置核销中状态
        this.isAffirming = true;
        this.showAffirmLoading = true;

        // 开牌
        this.batchManualOpen()
      }else{
        const item = this.couponList[0];
        if (item.manNumber == 0 && item.womanNumber == 0) {
          this.$toast("请至少添加一个男宾或者女宾");
          return false;
        }

        if (!this.guestTypeId) {
          this.$toast("请选择客人类型");
          return false;
        }
        console.log(this.guestTypeId);

        this.batchCreate().then((res) => {
          if (res.code == 1) {
            this.reset();
            localStorage.removeItem("keyCard");
            localStorage.setItem("consumptionSubjectId", res.data.join(','));
            this.$router.push("/list");
          }
        });

        // this.manualOpen().then((res) => {
        //   if (res.data.length > 0) {
        //     this.reset();
        //     localStorage.removeItem("consumptionSubjectId");
        //     localStorage.setItem("keyCard", res.data[0]);
        //     this.$router.push("/list");
        //   }
        // });

      }
    },
    batchCreate(){
      const data = {
        consumptionAreaId: localStorage.getItem("consumptionAreaId"),
        positionType:1,
        disableBarrier:false,
        registrations:[]
      }

      const item = this.couponList[0];
      if(item.manNumber>0){
        for (let i = 0; i < item.manNumber; i++) {
          const registration = {guests:[{sex: 1,guestTypeId: this.guestTypeId,}]}
          data.registrations.push(registration)
        }
      }
      if(item.womanNumber>0){
        for (let i = 0; i < item.womanNumber; i++) {
          const registration = {guests:[{sex: 2,guestTypeId: this.guestTypeId,}]}
          data.registrations.push(registration)
        }
      }
      return this.$post(this.Api.BatchCreate, data)
    },
    manualOpen(){
      const item = this.couponList[0];
      let data = {
        manQuantity: item.manNumber,
        femaleQuantity: item.womanNumber,
        guestTypeId: this.guestTypeId,
        setGuestTypeId: this.guestTypeId,
        consumptionAreaId: localStorage.getItem("consumptionAreaId"),
      };
      return this.$post(this.Api.ManualOpen, data)
    },
    batchManualOpen(){
      this.$toast.loading({
        message: "正在开牌中，请稍后....",
        forbidClick: true,
      });
      
      // 修改请求格式
      const data = {
        consumptionAreaId: localStorage.getItem("consumptionAreaId"),
        items:this.couponList.map(item=>{
          return {
            manQuantity:item.manNumber,
            femaleQuantity:item.womanNumber,
            guestTypeId:item.guestTypeId,
            setGuestTypeId:item.guestTypeId,
          }
        }),
      };

      this.$post(this.Api.BatchManualOpen, data).then((res) => {
        this.$toast.clear();
        if (res.code == 1) {
          console.log(res)

          // 批量核销优惠券
          this.batchUseCoupon(res.data)
          
        }else{
          this.loading = false;
          // 重置核销状态
          this.isAffirming = false;
          this.showAffirmLoading = false;
        }
      }).catch(()=>{
        this.$toast.clear();
        this.loading = false;
        // 重置核销状态
        this.isAffirming = false;
        this.showAffirmLoading = false;
      });

    },
    // 核销优惠券
    async useCoupons(coupon) {
      // let quantity = coupon.consumptionSubjectIdArray.length
      // const availablePersons = parseInt(coupon.availablePersons)
      // if(availablePersons>0){
      //   quantity = parseInt(quantity/availablePersons) + (quantity%availablePersons>0?1:0)
      // }
      let data = {
        consumptionSubjectIdArray:coupon.consumptionSubjectIdArray,
        thirdType: coupon.thirdType,
        consumptionAreaId: localStorage.getItem("consumptionAreaId"),
        quantity:1,
        description: "",
        ticketName:coupon.memberTicketName,
        memberCardNo:coupon.memberCardNo,
        appShopId:coupon.appShopId,
      };

      if(coupon.thirdType==4){
        data.couponCode = coupon.verify_token + "|" + coupon.encrypted_code + "|" + coupon.sku_id + "|" + coupon.pay_amount;
      }else if(coupon.thirdType==8){
        data.couponCode = coupon.code;
      }else if(coupon.thirdType==16){
        data.couponCode = coupon.verify_token + "|" + coupon.encrypted_code;
      }else if(coupon.thirdType==32){
        data.couponCode = coupon.verify_token + "|" + coupon.encrypted_code + "|" + coupon.pay_amount;
      }else if(coupon.thirdType == 64){
        data.couponCode = coupon.verify_token + "|" + coupon.encrypted_code + "|" + coupon.sku_id + "|" + coupon.pay_amount+ "|" + coupon.orderId
      }else if(coupon.thirdType == 128){
        data.couponCode = coupon.couponCode
      }else if(coupon.thirdType == 256){
        data.couponCode = coupon.code + "|" + coupon.verify_token + "|" + coupon.encrypted_code + "|" + coupon.sku_id
      }else{
        data.couponCode = coupon.code;
      }

      console.log(JSON.stringify(data));
      try{
        const res = await this.$post(this.Api.ticket2, data);
        console.log("----res: ", res);
        if (res.code === 1) {
          return true;
        }
      }catch(e){
        console.log('核销失败、请找前台处理')
      }
      return false;
    },
    // 批量核销优惠券
    batchUseCoupon(KeyCardList){
      const keyCards = [...KeyCardList]
      const tasks = []
      this.couponList.forEach((item,i)=>{
        const list = KeyCardList.splice(0,item.availablePersons )
        item.consumptionSubjectIdArray = list.map(e=>e.consumptionSubjectId)
        tasks[i++] = item
      })

      console.log('批量核销优惠券',tasks)

      if(tasks.length==0){
        return;
      }

      // 串行执行，第一个执行完再执行第二个
      (async () => {
        for (const item of tasks) {
          // 在这里才真正发起请求
          const result = await this.useCoupons(item);
          if(result==false){
            this.$toast('核销失败、请找前台处理')
            // 重置状态并重新打开扫码弹窗
            this.reset()
            return;
          }
        }
        this.couponList = []

        this.printEntrance(keyCards.map(item=>({KeyNo:item.keyCardNo ,consumptionSubjectId:item.consumptionSubjectId})))
        // 打印手牌
        setTimeout(() => {
          this.settleAccount(keyCards)
        }, keyCards.length*3000);
      })().catch((err) => {
        console.error(err);
          this.$toast('核销优惠券失败')
        // 出错时也要关闭弹窗和重置状态
        this.showAffirmLoading = false;
        this.isAffirming = false;
      });
    },
    // 结账和不离场
    async settleAccount(KeyCardList) {
      const consumptionAreaId = localStorage.getItem("consumptionAreaId");
      const terminalId = localStorage.getItem("terminalId") || "9";
      const consumptionSubjectIds = KeyCardList.map(item => item.consumptionSubjectId);
      const keyCardCodes = KeyCardList.map(item => item.keyCardCode);

      const data = {
        consumptionAreaId,
        consuptionSubjectIds: consumptionSubjectIds,
        settlementType: 1,
        real: false,
      };

      try {
        // 调单
        const orderRes = await this.$post(this.Api.transferOrder, data);

        const formData = {
          consumptionAreaId,
          consuptionSubjectIds: consumptionSubjectIds,
          settlementType: 1,
          description: "",
          orderId: orderRes.data.id,
          removedCertificateCodes: [],
          srcCertificateCodes: keyCardCodes,
          terminalId,
          reReceptionConsuptionSubjectIds: consumptionSubjectIds
        };

        this.$toast.loading({
          message: "正在结账...",
          forbidClick: true,
        });

        await this.$post(this.Api.NotLeave, formData);
        this.$toast.clear();

      } catch (err) {
        this.$toast.clear();
        this.$toast(err?.response?.data?.message || '结账失败');
      } finally {
        // 重置状态并重新打开扫码弹窗
        this.showAffirmLoading = false;
        this.isAffirming = false;
        this.isShowUseCoupon = true;
        this.setCouponCodeFocus();
      }
    },
    // 打印入场单
    async printEntrance(list) {
      //获取打印报表
      let data = {
        type: "P10",
      };
      let that = this;
      let printData = await this.requestUrlOrBody(data);

      axios.post(printData.requestUrl, 
        {
          consumptionSubjectIds:list.map(item => item.consumptionSubjectId).join(","),
          keyCards:list.map(item => item.KeyNo).join(",")
        }, {
        headers: {
          access_token: this.loginToken,
          x_req_application_id: 1,
          x_req_terminal: 9,
          x_req_store_id: localStorage.getItem("storeId"),
        },
      })
      .then(function (res) {
        // 打印多张入场单
        res.data.data.dataList.forEach((item, index) => {
          setTimeout(() => {
            that.dataSet(printData.body, [item]);
          }, 3000 * index); // 每隔1.5秒执行一次

          that.room = null
        });
      })
      .catch(function (error) {
      });
    },
    async requestUrlOrBody(data) {
      var requestData = {
        requestUrl: "",
        body: "",
      };
      let printData = await this.$fetchNo(
        this.Api.PrintReport + "/" + data.type
      );
      requestData.body = printData.data.body;
      requestData.requestUrl = printData.data.dataInterfaceUrl;
      let reportData = await this.$fetchNo(this.Api.ReportFormat, {
        reportId: printData.data.id,
      });
      if (reportData.data.items.length > 0) {
        let list = reportData.data.items.filter((item) => item.isDefault);
        if (list.length > 0) {
          requestData.body = list[0].body;
        }
      }
      return requestData;
    },
    dataSet(body, data) {
      this.load = false;
      var that = this;
      var num = data.printCount?data.printCount:0;
      var invoiceAddressValue = data.invoiceAddress?data.invoiceAddress:'';
      //创建报表对象
      var report = new window.Stimulsoft.Report.StiReport();
      // 加载文件
      report.load(body);
      //新建数据源
      var dataSet = new Stimulsoft.System.Data.DataSet("SimpleDataSet");
      //数据源填充数据
      delete data.printCount
      delete data.invoiceAddress
      dataSet.readJson(JSON.stringify(data));
      //给报表的数据源填充数据
      
      let hotelInfo = localStorage.getItem("hotelInfo") || "{}";
      hotelInfo = JSON.parse(hotelInfo);
      let storeName = hotelInfo.storeName || "云水荟";
      report.regData(dataSet.dataSetName, storeName, dataSet);
      var variableString = report.dictionary.variables.getByName("StoreName");
      variableString.value = storeName;
      if (num) {
        var printCount = report.dictionary.variables.getByName("printCount");
        printCount.value = num;
      }
      if(invoiceAddressValue){
        var invoiceAddress = report.dictionary.variables.getByName("invoiceAddress");
        invoiceAddress.value = invoiceAddressValue;
      }
      
      // report.regBusinessObject("StoreName", "酒店名称");
      // 创建报表
      viewer.report = report;
      this.loading = true;
      setTimeout(() => {
        that.loading = false;
      }, 1200);
      report.renderAsync( async function () {
        that.loading = false;
        await report.print();
      });
    },

    // 获取小程序二维码
    getCode() {
      let data = {
        page: "pages/index/bindCard/bindCard",
        // page: "pages/index/index",
        expiry: 12,
        check_Path: true,
        isHyaline: true,
        width: 546,
        data:{},
        envVersion: "release", //envVersion:  要打开的小程序版本。正式版为 release，体验版为 trial，开发版为 develop，默认 release
      };
      this.$post(this.Api.qrcode, data, { responseType: "blob" }).then(
        (res) => {
          let blob = new Blob([res]);
          let url = window.URL.createObjectURL(blob);
          this.imageUrl = url;
        }
      );
    },
    // 获取客人类型列表
    async getGuestType() {
      await this.$fetchNo(this.Api.GuestType, { status: 1 }).then((res) => {
        this.guestTypes = res.data.items;
        
        const guestTypeList = []
        res.data.items.forEach(item=>{
          if(item.terminals && item.terminals.find(e=>e.terminalId==9)){
            guestTypeList.push(item)
          }
        })

        if(guestTypeList.length==1){
          this.guestTypeId = guestTypeList[0].id
        }
      });
    },
    getUserPreference(){
      // 调用接口获取设置数据
      this.$fetchNo(this.Api.getUserPreference, {moduleName:'selfservice'}, 'get').then((res) => {
        if (res.data && res.data.length>0) {
          console.log('获取设置数据:', res.data);
          this.settingsData = JSON.parse(res.data)
          if(this.settingsData.selectableGuestType){
            this.guestTypeList = this.settingsData.selectableGuestType.map(item=>{
              return {
                id:item.id,
                name:item.name,
              }
            })
          }

          if(this.settingsData.defaultGuestType){
            this.guestTypeId = this.settingsData.defaultGuestType
          }

          if(this.settingsData.isUseCoupon){
            this.getTikTokSetting()
            this.getMeituanSetting()

            // 弹窗扫码获取优惠券code
            this.isShowUseCoupon = true
            this.setCouponCodeFocus()
          }else{
            this.couponList = [{
              key:'1',
              womanNumber:0,
              manNumber:0
            }]
          }

        }
      }).catch((err) => {
        console.error('获取设置失败:', err);
      });
    },
    // 数量减法
    minusNum(coupon,type) {
      if (type == "manNumber") {
        if (this.manNumber == 0) {
          coupon.manNumber = 0;
        } else {
          coupon.manNumber--;
        }
      } else {
        if (coupon.womanNumber == 0) {
          coupon.womanNumber = 0;
        } else {
          coupon.womanNumber--;
        }
      }
    },
    // 数量加法
    addNum(coupon,type) {
      // 检查总人数是否超过30人
      if (coupon.manNumber + coupon.womanNumber >= coupon.availablePersons) {
        this.$toast(`总人数不能超过${coupon.availablePersons}人`);
        return;
      }

      if (type == "manNumber") {
        coupon.manNumber++;
      } else {
        coupon.womanNumber++;
      }
    },
    openSettings(){
      this.showLogin = true;
    },
    openAddCoupon(){
      this.isShowUseCoupon = true;
      this.setCouponCodeFocus();
    },
    startCountdown(){
      // 重置倒计时
      this.countdownSeconds = 60;
      // 清除之前的定时器
      if(this.countdownTimer){
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      // 启动倒计时
      this.countdownTimer = setInterval(() => {
        this.countdownSeconds--;
        if(this.countdownSeconds <= 0){
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          this.closeUseCoupon();
        }
      }, 1000);
    },
    startResetCountdown(){
      // 重置倒计时
      this.resetCountdownSeconds = 60;
      // 清除之前的定时器
      if(this.resetCountdownTimer){
        clearInterval(this.resetCountdownTimer);
        this.resetCountdownTimer = null;
      }
      // 启动倒计时
      this.resetCountdownTimer = setInterval(() => {
        this.resetCountdownSeconds--;
        if(this.resetCountdownSeconds <= 0){
          clearInterval(this.resetCountdownTimer);
          this.resetCountdownTimer = null;
          this.reset(); // 倒计时结束调用重置
        }
      }, 1000);
    },
    openGuestTypePopup(){
      this.showGuestTypePopup = true;
    },
    closeGuestTypePopup(){
      this.showGuestTypePopup = false;
    },
    selectGuestType(id){
      this.guestTypeId = id;
      this.showGuestTypePopup = false;
    },
    deleteCoupon(index){
      this.couponList.splice(index, 1);
    }
  },
};
</script>

<style scoped lang="less">
.content {
  align-items: center;
  justify-content: center;
  .tab {
    margin-bottom: 32px;

    .tab-item {
      width: 341px;
      height: 105px;
      box-sizing: border-box;
      border: 4px solid #dadde1;
      border-radius: 15px;
      font-size: 44px;
      font-weight: 500;
      color: rgba(10, 25, 41, 0.6);
      &:first-child {
        border-right: 0;
        border-radius: 15px 0 0 15px;
      }
      &:nth-child(2) {
        border-left: 0;
        border-radius: 0 15px 15px 0;
      }
      &.on {
        background-color: #155bd4;
        border-color: #155bd4;
        color: #fff;
      }
    }
  }
  .code-box {
    width: 850px;
    height: 850px;
    border-radius: 24px;
    background-color: #ecf5ff;
    margin-top: 140px;
    .code {
      width: 546px;
      height: 546px;
      background-color: #fff;
      margin-bottom: 90px;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tip {
      font-size: 40px;
      color: #363d45;
      font-weight: 500;
    }
  }

  .guest-list{
    background: #F2F3F7;
    overflow: auto;
    height: calc(100vh - 732px);
    margin-bottom: 200px;
  }

  .guest-box {
    margin: 24px;
    background: #ffffff;
    border-radius: 32px;

    .top{
      .seq-number{
        color: white;
        background: #0068F0;
        border-radius: 16px 0px 16px 0px;
        width: 128px;
        text-align: center;
        font-size: 35px;
      }
  
      .close{
        font-size: 30px;
        color: #8b8b8b;
        margin: 16px 16px 0 0;
      }
    }

    .title {
      margin: 32px 32px 0px 32px;
      font-size: 35px;
      color: #0A1929;

      .name{
        color: #1D2129;
        font-size: 50px;
        margin-bottom: 16px;

        span{
          color: #FF7D00;
          margin-left: 16px;
          font-size: 35px;
        }
      }
    }

    .guest-sex {
      box-sizing: border-box;
      margin-bottom: 45px;
      padding: 32px 32px;

      .sex-item {
        gap: 32px;
        border-radius: 32px;
        border: 6px solid #E5E6EB;
        padding: 32px 96px;

        .sex {
          img {
            width: 120px;
            height: 120px;
            margin-right: 16px;
          }
          span {
            font-size: 40px;
            color: #1a1e22;
            line-height: 50px;
          }
        }
        .num {
          img {
            width: 80px;
            height: 80px;
          }
          .number {
            font-size: 44px;
            color: #333333;
            font-weight: 700;
            width: 100px;
            line-height: 80px;
            text-align: center;
          }
        }
      }
    }
    
  }

  .add-coupon{
    text-align: center;
    background: white;
    padding: 12px;
    color: #777777;
    margin: 24px;
  }

  .btn-bottom{
    position: fixed;
    bottom: 0px;
    padding-bottom: 32px;
    width: 100%;
    background: white;
    text-align: center;
    gap: 64px;
    display: flex;
    flex-flow: column;
    padding: 32px 16px;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);

    .title{
      width: 600px;
    }

    .guest-type {
      width: 100%;
      box-sizing: border-box;

      select {
        width: 100%;
        height: 120px;
        background: #f4f4f4;
        box-shadow: inset 2px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 16px;
        font-size: 44px;
        text-indent: 32px;
        color: #1a1e22;
        border: 0;
        &::placeholder {
          color: #b9bdc6;
        }
      }
    }
    .btn-group {
      width: 100%;
      box-sizing: border-box;
      padding: 0 105px;
      .btn-item {
        width: 392px;
        height: 140px;
        border-radius: 16px;
        background-color: #d3d3d3;
        font-size: 40px;
        color: #1a1e22;
        font-weight: 700;
        &.affirm {
          color: #fff;
          background-color: #155bd4;
        }
      }
    }
  }

}

.setting-btn{
  width: 180px;
  text-align: right;
  height: 120px;
  line-height: 120px;
}

.pay-popup {
  width: 100%;
  height: 100vh;
  position: absolute;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  .pay-window {
    width: 100%;
    height: 100%;
    position: relative;

    .pay-tip {
      width: 744px;
      height: 880px;
      background-color: #fff;
      border-radius: 32px;
      box-sizing: border-box;
      position: relative;
      z-index: 9999;
      p {
        font-size: 40px;
        line-height: 48px;
        color: #1a1e22;
        font-weight: 500;
      }
      .tip {
        font-size: 32px;
        line-height: 38px;
        color: #999999;
        font-weight: 400;
      }
      .pay-img {
        width: 372px;
        height: 372px;
        margin-top: 50px;
        margin-bottom: 30px;
        .scan-img {
          width: 100%;
          height: 100%;
        }
      }
      .cancel-account {
        width: 100%;
        padding: 30px 0;
        cursor: pointer;
        font-size: 46px;
        line-height: 36px;
        color: #0068f0;
        font-weight: bold;
      }
      .countdown {
        width: 100%;
        padding: 20px 0;
        font-size: 30px;
        line-height: 36px;
        color: #ff6b00;
        font-weight: 500;
        text-align: center;
      }
      .loading-text {
        font-size: 48px;
        font-weight: bold;
        color: #1a1e22;
        margin-bottom: 20px;
      }
      .loading-subtext {
        font-size: 32px;
        color: #999999;
      }
      .explanation{
        p{
          font-size: 32px;
          color: #ff0000d1;
          text-align: center;
        }
      }
    }
    .scan-box {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 9998;
      .box {
        width: 100%;
        height: 100%;
        background: transparent;
        font-size: 1px;
        color: transparent;
        position: absolute;
      }
    }
    select{
      margin: 220px 10%;
      width: 80%;
      padding: 40px;
    }
  }
}

.flex-baseline{
  align-items: baseline;
}

// 客人类型选择器
.guest-type-selector {
  width: 100%;
  height: 120px;
  background: #f4f4f4;
  box-shadow: inset 2px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  font-size: 44px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1a1e22;
  cursor: pointer;
  span {
    flex: 1;
  }
  .arrow-icon {
    width: 40px;
    height: 40px;
  }
}

// 底部弹窗
.bottom-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  .bottom-popup-content {
    width: 100%;
    background: #fff;
    border-radius: 32px 32px 0 0;
    max-height: 70%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 40px 32px;
      border-bottom: 1px solid #eee;

      .popup-title {
        font-size: 44px;
        font-weight: bold;
        color: #1a1e22;
      }

      .close-btn {
        font-size: 60px;
        color: #999;
        cursor: pointer;
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .popup-body {
      flex: 1;
      overflow-y: auto;
      padding: 20px 32px;

      .guest-type-item {
        padding: 32px;
        margin-bottom: 16px;
        border-radius: 16px;
        background: #f5f5f5;
        font-size: 40px;
        color: #1a1e22;
        cursor: pointer;
        text-align: center;

        &.active {
          background: #155bd4;
          color: #fff;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

</style>